export default __webpack_public_path__ + "static/media/tuvil.13dca651.svg";